import { Slide } from 'components/UI/V2/Carousel/Slide';

const handleLearnMore = () => {
    console.log('Learn more clicked');
};

const IMAGE_VIDEO = 'images/sliders/placeholder-video.png';

export const clientSlides: Slide[] = [
    {
        id: 1,
        stepNumber: 1,
        title: 'Add pet parent information.',
        description:
            "Create a pet parent profile with either an email <strong><u><i>or</i></u> </strong> phone number. You can also add emergency contacts, and internal-use tags like 'VIP' or 'No Show'.",
        image: 'images/sliders/client/slider-client-1.jpg'
    },
    {
        id: 2,
        stepNumber: 2,
        title: 'Add multiple pets under one family.',
        description:
            'Create individual profiles for each pet. Include basic facts like their size and breed, along with internal notes, personality traits, health history, and vaccine records.',
        image: 'images/sliders/client/slider-client-2.jpg'
    },
    {
        id: 3,
        stepNumber: 3,
        title: 'Need help moving your client list?',
        description: 'Our support team will import your contacts from other software for free!',
        image: 'images/sliders/client/slider-client-3.jpg',
        primaryButton: {
            text: 'Contact us',
            href: 'mailto:help@cuddlesapp.com',
            target: '_blank',
            rel: 'noreferrer',
            color: '#EAB464',
            hoverColor: '#C18733'
        }
    }
];
